export function getCurrentLanguage(): string {
  const currentOptions = localStorage.getItem("persist:root");
  return currentOptions
    ? JSON.parse(JSON.parse(currentOptions).language).locale
    : "en";
}
